<template>
  <div class="vx-col lg:w-1/2 md:w-full sm:w-full w-full mb-base">
    <vx-card :title="settings.label">
      <vue-apex-charts
        type="pie"
        height="auto"
        :options="pieChart.chartOptions"
        :series="pieChart.series"
      ></vue-apex-charts>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      pieChart: {
        animations: {
          enabled: false,
          easing: "easeinout",
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
        width: "90%",
        height: "100%",
        series: this.settings.value.val,

        chartOptions: {
          animations: {
            enabled: false,
            easing: "linear",
            speed: 0,
            animateGradually: { enabled: false, delay: 0 },
            dynamicAnimation: { enabled: false, speed: 0 },
          }, 
          labels: this.settings.value.label,
          colors: [
            "#F5DEB3",
            "#28C76F",
            "#EA5455",
            "#FF9F43",
            "#AAFF00",
            "#7367F0",
          ],
          legend: {
            fontSize: "16px",
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: "18px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: "bold",
            },
          },
          responsive: [
            {
              breakpoint: 680,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  props: {
    settings: Object,
    default: {},
  },
  created() {
    console.log("seetings::", this.settings);
  },
};
</script> 